// Development mode utilities
// Provides secure access to dev features only on local networks

/**
 * Check if the current hostname is a local IP address or oasis domain
 * @returns {boolean} true if accessing from local network or oasis.simpleodds.app
 */
export const isLocalIP = () => {
  const hostname = window.location.hostname;
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.startsWith('192.168.') ||
    hostname.startsWith('10.') ||
    hostname.startsWith('172.') ||
    hostname === '::1' || // IPv6 localhost
    hostname.includes('.local') || // Local network names
    hostname === 'oasis.simpleodds.app' // Oasis staging environment
  );
};

/**
 * Check if a dev mode feature is enabled via URL parameter
 * @param {string} paramName - The URL parameter name to check
 * @returns {boolean} true if parameter is 'true' and on local network
 */
export const isDevModeEnabled = (paramName) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(paramName) === 'true' && isLocalIP();
};

/**
 * Get URL parameter value only if on local network
 * @param {string} paramName - The URL parameter name
 * @returns {string|null} parameter value or null if not on local network
 */
export const getDevModeParam = (paramName) => {
  if (!isLocalIP()) return null;
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(paramName);
};